import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { ListCustomCell } from '@shared/modules/list/interfaces/list-custom-cell.interface';
import { publicFile } from '@shared/helpers/public-file.helper';
import { UIModule } from '@shared/modules/ui/ui.module';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'project-responsible-company-cell',
  templateUrl: './project-responsible-company-cell.component.html',
  styleUrls: ['./project-responsible-company-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [UIModule, MatTooltipModule]
})
export class ProjectResponsibleCompanyCellComponent implements ListCustomCell {
  @ViewChild('template') template;

  imageUrl(row: any) {
    return publicFile(row?.basicDataBox?.responsibleEmployee?.userPerson?.photo, 100);
  }
}
